'use client';

import { ChakraProvider as ChakraUIProvider } from '@chakra-ui/react';
import theme from './theme';
/**
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export default function ChakraProvider({ children }) {
  return <ChakraUIProvider theme={theme}>{children}</ChakraUIProvider>;
}
